import type { Translate } from 'next-translate';
import React from 'react';
import type { LandingMain } from '@/types';
import { GradientButton } from '../GradientButton';
import { MainMedia } from '../MainMedia';
import styles from './MainCta.module.scss';

interface Props {
	data: LandingMain['cta'];
	t: Translate;
	toolsHref: string;
	onCtaClick: () => void;
}

export const MainCta: React.FC<Props> = ({
	data,
	t,
	toolsHref,
	onCtaClick,
}) => (
	<section className={styles['cta']}>
		<MainMedia
			media={data.media}
			alt={t(data.media.alt)}
			sizes='100vw'
			className={styles['cta__background']}
		/>

		<h2 className={styles['cta__title']}>{t(data.title)}</h2>
		<GradientButton
			href={toolsHref}
			text={t(data.buttonText)}
			onClick={onCtaClick}
			className={styles['cta__button']}
		/>
	</section>
);
